module.exports = __webpack_public_path__ + "static/img/img18.7383df75.png";